// @flow
import type { License } from 'state/types';
import { SN_LENGTH } from 'util/constants';

// Product Ids
const SN_TYPE_STUDIO = 'PS';
const SN_TYPE_SERVER = 'PP';
export const SN_TYPE_DEMO = 'PD';

export function daysUntilExpiration(license: License) {
  let daysRemaining = 0;
  if (license.dateExpires) {
    daysRemaining = Math.trunc(
      (new Date(license.dateExpires) - Date.now()) / 1000 / 60 / 60 / 24
    );
    if (daysRemaining < 0) {
      daysRemaining = 0;
    }
  }
  return daysRemaining;
}

function parseLicenses(rawText: string) {
  return rawText.trim().split(/[\s]+/);
}

export function containsValidLicenses(rawText: ?string) {
  // (?:x) = non-capturing group. Faster than a capturing group.
  // x{n} matches exactly n occurrences of the preceding item x.
  // So ^(?:[a-zA-Z0-9]{4}-){5} matches XXXX-XXXX-XXXX-XXXX-XXXX- followed by XXXX.
  const validFormat = /^(?:[a-zA-Z0-9]{4}-){5}[a-zA-Z0-9]{4}$/;

  if (rawText && rawText.length >= SN_LENGTH) {
    return parseLicenses(rawText).every(sn => validFormat.test(sn));
  }

  return false;
}

export function isMainProductCode(productId: string) {
  const serverLicenseIds = [SN_TYPE_STUDIO, SN_TYPE_SERVER, SN_TYPE_DEMO];
  return serverLicenseIds.includes(productId);
}

function isMainProductLicense(license: License) {
  return isMainProductCode(license.productId);
}

export function hasMainProductLicense(licenses: License[]) {
  return licenses.some(lic => isMainProductLicense(lic));
}

export function isDemoMode(licenses: License[]) {
  return licenses.some(license => license.productId === SN_TYPE_DEMO);
}



// WEBPACK FOOTER //
// ./src/util/licenseUtils.js